import Player from "@vimeo/player";

const playFullscreen = (iframe) => {
    const player = new Player(iframe);

    player.on('play', () => {
        player.requestFullscreen().catch(() => {});
    });

    player.play().catch(() => {});

    return player;
};

export default playFullscreen;
